import React from "react";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";

export default function BulkActionBar({ count = 0, label, onClear, children }) {
  const { t } = useTranslation("common");
  const open = count > 0;

  return (
    <div
      className={`fixed bottom-0 left-1/2 z-[200] -translate-x-1/2 transition-transform duration-300 ${
        open ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ transitionTimingFunction: "cubic-bezier(.34,1.56,.64,1)" }}
    >
      <div className="flex max-w-[95vw] flex-wrap items-center gap-2.5 rounded-t-xl border border-glass-border bg-glass-bg px-5 py-3 text-brand-contrast backdrop-blur-sm">
        <span className="whitespace-nowrap text-[13px] font-bold text-brand">
          {count} {label ?? t("table.selected")}
        </span>

        <span className="h-5 w-px bg-glass-divider" />

        {children}

        <span className="h-5 w-px bg-glass-divider" />

        <button
          type="button"
          onClick={onClear}
          title={t("table.clearSelection")}
          className="flex items-center text-brand opacity-80 transition-opacity hover:opacity-100"
        >
          <IoClose size={18} />
        </button>
      </div>
    </div>
  );
}

export function BulkActionButton({
  icon: Icon,
  label,
  onClick,
  disabled = false,
  variant = "default",
  className = "",
  children,
}) {
  const variants = {
    default: "bg-ui-inverted border-transparent hover:opacity-90",
    danger:
      "bg-state-danger/25 border-state-danger/40 hover:bg-state-danger/[.45]",
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center gap-1.5 whitespace-nowrap rounded-md border px-2.5 py-1.5 text-xs font-semibold text-brand-contrast transition-colors ${
        variants[variant] || variants.default
      } ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"} ${className}`}
    >
      {Icon && <Icon className="h-3.5 w-3.5" />}
      {label}
      {children}
    </button>
  );
}
